import { render } from "./index.vue?vue&type=template&id=23c3701f&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=23c3701f&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=23c3701f&lang=less"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3701f"]])

export default __exports__